import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import mitt from 'mitt'

const emitter = mitt()

export const useMainStore = defineStore('main', () => {
  // api消息
  type Message = {
    type: string
    msg: string
  }
  const messages = ref<Message[]>([])

  const msgInfo = ref<Message>({
    type: 'info',
    msg: '',
  })

  const addMessages = (msg: Message) => {
    msgInfo.value = msg
    messages.value.push(msg)
  }
  // api消息-end

  // 监测消息
  const monitoringStatus = ref(0) // 0空闲, 1监测中, 2监测准备中
  //   const monitoringStatusText = computed(() => {
  //     switch (monitoringStatus.value) {
  //       case 0:
  //         return '空闲';
  //       case 1:
  //         return '监测中';
  //       case 2:
  //         return '监测准备中';
  //     }
  //   })
  const setMonitoringStatus = (status: number) => {
    monitoringStatus.value = status
  }
  // 监测消息-end

  // 基础信息
  const subsystemId = ref(1)
  const localSubsystemId = localStorage.getItem('subsystemId')
  console.log('localSubsystemId', localSubsystemId)
  if (localSubsystemId) {
    subsystemId.value = parseInt(localSubsystemId)
  }
  const setSubsystemId = (val: number) => {
    if (typeof val !== 'number') return
    subsystemId.value = val
    localStorage.setItem('subsystemId', val.toString())
  }

  const sessionid = ref('')
  const localSessionid = localStorage.getItem('sessionid')
  if (localSessionid) {
    sessionid.value = localSessionid
  }
  const setSessionid = (val: string) => {
    if (typeof val !== 'string') return
    sessionid.value = val
    localStorage.setItem('sessionid', val)
  }

  const segmentid = ref('')
  const localSegmentInfo = localStorage.getItem('segmentInfo')
  if (localSegmentInfo) {
    segmentid.value = JSON.parse(localSegmentInfo).segmentid
  }
  const setSegmentid = (val: string) => {
    const oloSegmentInfo = localStorage.getItem('segmentInfo')
    if (typeof oloSegmentInfo !== 'object' || oloSegmentInfo === null) return
    const data = JSON.parse(oloSegmentInfo)
    data.segmentid = val
    data.max_duration = -1
    segmentid.value = data.segmentid
    localStorage.setItem('segmentInfo', JSON.stringify(data))
  }
  const setSegmentInfo = (data: any) => {
    if (typeof data !== 'object') return
    segmentid.value = data.segmentid
    localStorage.setItem('segmentInfo', JSON.stringify(data))
  }

  // 基础信息-end

  /** 是否冻结OSG */
  const isFreezeOSG = ref(false)

  const setIsFreezeOSG = (val: boolean) => {
    isFreezeOSG.value = val
  }

  const patientInfo = ref({})

  const localPatientInfo = localStorage.getItem('patientInfo')
  if (localPatientInfo) {
    patientInfo.value = JSON.parse(localPatientInfo)
  }

  // 事件
  interface EventInfo {
    记录时间: Date
  }

  interface EventType {
    event_info: EventInfo
  }
  const events = ref<EventType[]>([
    // {
    //   "event_id": 1,
    //   "visit_id": 46,
    //   "event_type": "FETAL_MOVEMENT",
    //   "event_info": {
    //     "记录内容": "测试",
    //     "操作人": "操作人",
    //     "记录时间": new Date().toISOString()
    //   },
    //   "created_at": "2025-09-01T01:11:08.149Z",
    //   "updated_at": "2025-09-01T01:11:08.149Z"
    // }
  ])
  // 事件-end


  const subsysStatus = ref('INITIAL') // STANDBY,INITIAL,CHECKIN,LINKED
  


  return {
    // api消息
    msgInfo,
    messages,
    addMessages,
    // 监测消息
    monitoringStatus,
    setMonitoringStatus,
    // 基础信息
    subsystemId,
    setSubsystemId,
    sessionid,
    setSessionid,
    segmentid,
    setSegmentid,
    setSegmentInfo,
    //
    isFreezeOSG,
    setIsFreezeOSG,
    // 患者信息
    patientInfo,
    emitter,
    events,

    subsysStatus
  }
})
